import { Navigate, Route, Routes } from 'react-router-dom'

import { Ladeanzeige } from './bausteine/Hinweise'
import { Rahmen } from './bausteine/Rahmen'
import { useKonto } from './konto/KontoKontext'
import { TerminBestaetigen, Terminbuchung } from './oeffentlich/Terminbuchung'
import { Portal } from './portal/Portal'
import { Anmeldung } from './seiten/Anmeldung'
import { Faellig } from './seiten/Faellig'
import { Bausteine } from './seiten/Bausteine'
import { Konto } from './seiten/Konto'
import { KundeDetail } from './seiten/KundeDetail'
import { Kunden } from './seiten/Kunden'
import { Pruefbogen } from './seiten/Pruefbogen'
import { Pruefungen } from './seiten/Pruefungen'
import { SpielplatzDetail } from './seiten/SpielplatzDetail'
import { Terminanfragen } from './seiten/Terminanfragen'
import { Abrechnung } from './seiten/Abrechnung'
import { Belege } from './seiten/Belege'
import { BelegDetail } from './seiten/BelegDetail'
import { Mandanten } from './seiten/Mandanten'
import { Pruefpunkte } from './seiten/Pruefpunkte'
import { Tunnelvorlagen } from './seiten/Tunnelvorlagen'
import { Uebersicht } from './seiten/Uebersicht'
import { Verwaltung } from './seiten/Verwaltung'
import { Warteschlange } from './seiten/Warteschlange'

/**
 * Drei getrennte Bereiche in einer Anwendung:
 *
 *   /termin/*   öffentlich, ohne Anmeldung
 *   /portal/*   Betreiberportal des Bauhofs, eigener Anmeldeweg
 *   alles übrige  Prüfbüro
 *
 * Die Reihenfolge ist wichtig: die öffentlichen und die Portalpfade müssen vor
 * der Anmeldeprüfung des Prüfbüros stehen. Sonst sähe ein Bauhofmitarbeiter
 * das Anmeldeformular des Prüfbüros.
 */
export function App() {
  return (
    <Routes>
      <Route path="/termin" element={<Terminbuchung />} />
      <Route path="/termin/bestaetigen" element={<TerminBestaetigen />} />
      <Route path="/portal/*" element={<Portal />} />
      <Route path="/*" element={<Pruefbuero />} />
    </Routes>
  )
}

function Pruefbuero() {
  const { zustand } = useKonto()

  if (zustand === 'prueft') {
    return <Ladeanzeige text="Prüft die Anmeldung …" />
  }

  if (zustand === 'abgemeldet') {
    return <Anmeldung />
  }

  return (
    <Rahmen>
      <Routes>
        <Route path="/" element={<Uebersicht />} />
        <Route path="/kunden" element={<Kunden />} />
        <Route path="/kunden/:kundeId" element={<KundeDetail />} />
        <Route path="/spielplaetze/:platzId" element={<SpielplatzDetail />} />
        <Route path="/pruefungen" element={<Pruefungen />} />
        <Route path="/pruefungen/:pruefungId/bogen" element={<Pruefbogen />} />
        <Route path="/aufgaben" element={<Faellig />} />
        <Route path="/terminanfragen" element={<Terminanfragen />} />
        <Route path="/bausteine" element={<Bausteine />} />
        <Route path="/pruefablaeufe" element={<Tunnelvorlagen />} />
        <Route path="/pruefpunkte" element={<Pruefpunkte />} />
        <Route path="/abrechnen" element={<Abrechnung />} />
        <Route path="/belege" element={<Belege />} />
        <Route path="/belege/:belegId" element={<BelegDetail />} />
        <Route path="/verwaltung" element={<Verwaltung />} />
        <Route path="/pruefbueros" element={<Mandanten />} />
        <Route path="/konto" element={<Konto />} />
        <Route path="/warteschlange" element={<Warteschlange />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Rahmen>
  )
}
